module.exports = __webpack_public_path__ + "img/HA.92868a7.svg";